module.exports = __webpack_public_path__ + "img/BN.26d92cda.svg";